var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { apiClient } from '../interceptor/interceptor';
/**
 * Fetch dynamic tab configuration for a page.
 *
 * Backend contract:
 * - GET /screener/tabs?pageName={pageName}&patientId={patientId}
 * - Returns which tabs/components to render based on patient status
 */
export const fetchTabs = (pageName, patientId) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield apiClient.get('/screener/tabs', {
        params: { pageName, patientId }
    });
    return response.data;
});
